import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SESSION_URLS } from "../../api/AdminUrls";
import { post } from "../../services/smartApiService";

// Define TypeScript interface for session data
interface SessionData {
    sessionNumber: number;
    date: string;
    candidates: number;
    attended: number;
    passed: number;
    failed: number;
}

// Example session data (this can be replaced with API data)
const sessions: SessionData[] = [
    { sessionNumber: 1, date: "2024-02-10", candidates: 100, attended: 90, passed: 75, failed: 15 },
    { sessionNumber: 2, date: "2024-02-11", candidates: 120, attended: 110, passed: 85, failed: 25 },
    { sessionNumber: 3, date: "2024-02-12", candidates: 150, attended: 140, passed: 100, failed: 40 },
];

// Function to calculate pass percentage
const calculatePassPercentage = (passed: number, attended: number): string => {
    return attended ? ((passed / attended) * 100).toFixed(2) + "%" : "0%";
};

const SessionCards: React.FC = () => {
    const [tabData, setTabData] = useState<any[]>([]);
    const navigate = useNavigate();
    const loadTableData = () => {
        let URL = SESSION_URLS.GET_ALL_TRAINER;
        let data_in = {
            status: "today"
        };
        const subscription = post(URL, data_in).subscribe((response) => {
            setTabData(response.data);
        });
        return () => {
            subscription.unsubscribe();
        };
    };

    useEffect(() => {
        loadTableData();
    }, []);

    const getButtonTitle = (status: String) => {
        if (status === "active") {
            return "View & Start Session";
        } else if (status === "started") {
            return "View Session";
        } else if (status === "completed") {
            return "Results";
        }
    }

    const getButtonClass = (status: String) => {
        if (status === "active") {
            return "is-danger";
        } else if (status === "started") {
            return "is-link";
        } else if (status === "completed") {
            return "is-success";
        }
    }

    
  const updateTimeLeft=(endTime:number)=>{
    const currentTime = Math.floor(Date.now() / 1000); // Current Unix timestamp in seconds   
    const remaining = Math.max(0, Math.floor((endTime - currentTime) / 60));
    return remaining;
   // console.log("remaining minutes " , remaining);
    //setTimeLeft(remaining * 60);
  }



    return (
        <div className="container mt-5">
            <div className="columns is-multiline">
                {tabData.map((session, index) => (
                    <motion.div
                        key={index}
                        className="column is-one-third"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                    >
                        <motion.div
                            className="card"
                            whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)" }}
                            transition={{ duration: 0.3 }}
                        >
                            <header className="card-header">
                                <p className="card-header-title">{session.session_id}</p>
                                {/* <span className="tag is-info mr-3 mt-2">{changeDateTimeZone(session.date)}</span> */}
                                <span className="tag is-info mr-3 mt-2">{session?.status}</span>
                            </header>
                            <div className="card-content">
                                <div className="content">
                                    <table>
                                        <tr>
                                            <th>Number of Loco Pilots:</th> <td> {session.total_trainees || 0}</td>
                                        </tr>
                                        {session?.status === "started" && <>
                                            <tr>
                                                <th>Online</th> <td> {session.active_users || 0}</td>
                                            </tr>
                                            <tr>
                                                <th>Completed</th> <td> {session.completed_users || 0}</td>
                                            </tr>                                           
                                            <tr>
                                                <th>Remaining Time(mm)</th><td>{updateTimeLeft(session?.end_time||0)} </td>
                                            </tr>
                                        </>
                                        }
                                        {session?.status === "completed" && <>
                                            <tr>
                                                <th>Assessed</th> <td> {session.completed_users || 0}</td>
                                            </tr>
                                            {/* <tr>
                                                <th>Pass</th> <td> {session.passed || 0}</td>
                                            </tr> */}
                                            <tr>
                                                <th>Avg Score</th> <td> {calculatePassPercentage(session.passed, session.completed_users)}</td>
                                            </tr>
                                        </>
                                        }
                                    </table>


                                </div>
                            </div>
                            <footer className="card-footer  has-text-centered">
                                <motion.button
                                    className={`button card-footer-item ${getButtonClass(session?.status)}`}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    onClick={() => navigate("/admin/session/" + session?.ID)}
                                >
                                    {getButtonTitle(session?.status)}
                                </motion.button>
                            </footer>
                        </motion.div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default SessionCards;
